var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifications"},[_c('transition-group',{attrs:{"name":"list","mode":"in-out"}},_vm._l((_vm.notifications),function(notification){return _c('notification',{key:notification.timestamp.getTime(),attrs:{"message":notification.message,"icon":notification.icon,"type":notification.type,"timestamp":notification.timestamp,"timeout":notification.timeout,"vertical-align":notification.verticalAlign,"horizontal-align":notification.horizontalAlign},on:{"on-close":_vm.removeNotification}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/NotificationPlugin/Notifications.vue